import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CommonUiCommonRenderingsModule } from '@legacy/common-ui-common-renderings';

import { CommonUiUtilityComponentsModule } from '@legacy/common-ui-utility-components';
import { AnalyticsDirectivesModule } from '@analytics/events';

import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';

/**
 * @deprecated Most components, pipes and directives in this module can be imported directly
 */
@NgModule({
  imports: [TranslatePipe, TranslateDirective],
  exports: [
    CommonModule,
    JssModule,
    RouterModule,
    TranslatePipe,
    TranslateDirective,
    FontAwesomeModule,
    CommonUiCommonRenderingsModule,
    CommonUiUtilityComponentsModule,
    AnalyticsDirectivesModule,
  ],
})
export class DefaultComponentModule {}
